// AI Generated Component
import { Component, OnInit, OnDestroy } from '@angular/core';
import { Subject } from 'rxjs';
import { TranslateService } from '@client/app/services/translate/translate.service';
import { LinksRepoService } from '@client/app/services/api/links-repo/links-repo.service';
import { MonNumberPipe } from '@monsido/core/locale/pipes/mon-number.pipe';
import { MON_EVENTS } from '@monsido/core/constants/mon-events.constant';
import { ActiveFeatureService } from '@client/ng2/services/active-feature/active-feature.service';
import { PagesEmailComponent } from '@client/app/components/pages/emails/pages-email.component';
import { FormGlobalPolicyComponent } from '@client/app/forms/global-policy/form-global-policy.component';
import { BaseContainerComponentController } from '@client/app/blocks/base/base.controller';

/**
 * Inventory email component
 */
@Component({
    selector: 'inventory-email',
    templateUrl: './inventory-email.component.html',
    standalone: false,
})
export class InventoryEmailComponent extends BaseContainerComponentController implements OnInit, OnDestroy {
    private destroy$ = new Subject<void>();

    // Properties matching original component
    public emails: any = [];
    public subheaderTranslation: string = '';
    public promise: Promise<any> | null = null;
    public showPolicy: boolean = false;
    public scanDocuments: boolean = false;
    public exports: any[] = [];

    constructor (
        private linksRepoService: LinksRepoService,
        private translateService: TranslateService,
        private monNumberPipe: MonNumberPipe,
        private activeFeatureService: ActiveFeatureService,
    ) {
        super({ table: true, pages: true });
        this.currentSort.direction = 'asc';
        this.currentSort.by = 'url';
    }

    ngOnInit (): void {
        this.initializeComponent();
    }

    ngOnDestroy (): void {
        this.destroy$.next();
        this.destroy$.complete();
    }

    private initializeComponent (): void {
        this.search = '';
        this.showPolicy = this.activeFeatureService.isFeatureActivePure('policies_all');
        this.scanDocuments = this.sessionService.domain?.scan?.scan_documents || false;
        this.emails.total = 0;
        this.subheaderTranslation = '';
        this.exports = [
            {
                name: this.translateService.getString('Email Addresses'),
                data: {
                    category: 'inventory_email',
                },
            },
            {
                name: this.translateService.getString('Email Addresses (Extended)'),
                data: {
                    category: 'inventory_email_extended',
                },
            },
        ];
        this.getPage();
    }

    public override getPage (): void {
        const params: any = {
            type: 'email',
            page: this.page,
            page_size: this.pageSize,
            search: this.search,
            page_fixed: false,
            sort_dir: this.currentSort.direction,
            sort_by: this.currentSort.by,
        };

        this.promise = this.linksRepoService.getAll(params).then((data) => {
            this.emails = data;
            this.getSubHeaderDescription();
        });
    }

    private getSubHeaderDescription (): void {
        const total = Number(this.emails.total) || 0;
        const formattedNumber = this.monNumberPipe.transform(total, '0,0');
        this.subheaderTranslation = this.translateService.getPlural(
            total,
            '1 result',
            '[[count]] results',
            { count: formattedNumber },
            '',
        );
    }

    public showPages (email: any, type: string): void {
        const params = {
            body: PagesEmailComponent,
            size: 'md',
            data: { email: email, type: type },
        };

        this.monEventsService.run(MON_EVENTS.LOAD_DIALOG, { params });
    }

    public createEmailPolicy (email: any): void {
        const params = {
            body: FormGlobalPolicyComponent,
            size: 'fw',
            data: {
                policy: {
                    subject: 'page_html',
                    mode: 'violation',
                    rules: [
                        {
                            case_sensitive: true,
                            inverse: false,
                            multiline: false,
                            name: 'Find pages with links that contain the email: ' + email.url,
                            operator: 'contains',
                            query: email.url,
                            sub_entry: '',
                            type: 'link_url',
                        },
                    ],
                },
            },
        };

        this.monEventsService.run(MON_EVENTS.LOAD_DIALOG, { params, callback: () => this.getPage() });
    }

    public trackByFn (index: number, item: any): any {
        return item.id || index;
    }
}
